import { render, staticRenderFns } from "./TianyiVideo.vue?vue&type=template&id=05500084&scoped=true&"
import script from "./TianyiVideo.vue?vue&type=script&lang=js&"
export * from "./TianyiVideo.vue?vue&type=script&lang=js&"
import style0 from "./TianyiVideo.vue?vue&type=style&index=0&id=05500084&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05500084",
  null
  
)

export default component.exports